// #region Constants

const DEFAULT_QUALITY = 0.5;

// #endregion Constants

const canvas = document.createElement('canvas');

/**
 * Generate a thumbnail from what is being displayed in the specified video
 * element.
 */
export function thumbnailFromElement(element) {
  const aspectratio = element.videoHeight / element.videoWidth;
  
  canvas.width = 100;
  canvas.height = Math.floor(canvas.width * aspectratio);

  const context = canvas.getContext('2d');
  context.drawImage(element, 0, 0, canvas.width, canvas.height);

  return canvas.toDataURL('image/jpeg', DEFAULT_QUALITY);
}